import { createContext, type ReactNode, useContext } from 'react';

export interface CountdownDisplayValue {
  remainingMs: number;
  isUrgent: boolean;
  hasExpired: boolean;
}

const CountdownDisplayContext = createContext<CountdownDisplayValue | null>(null);

export function CountdownDisplayProvider({
  value,
  children,
}: {
  value: CountdownDisplayValue;
  children: ReactNode;
}) {
  return <CountdownDisplayContext.Provider value={value}>{children}</CountdownDisplayContext.Provider>;
}

export function useCountdownDisplay(): CountdownDisplayValue {
  const value = useContext(CountdownDisplayContext);
  if (value === null) {
    return { remainingMs: 0, isUrgent: false, hasExpired: false };
  }
  return value;
}
